import {Button, type ButtonVariant} from '@wandb/weave/components/Button';
import React, {useCallback} from 'react';

import {trackPanelBankEvent} from '../../services/analytics';
import type * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';

type PinSectionButtonProps = {
  className?: string;
  buttonVariant: ButtonVariant;
  pinPanelBankSection?: (sectionId: PanelBankSectionConfigTypes.Ref) => void;
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
  isPinned: boolean;
};

export const PinSectionButton = ({
  pinPanelBankSection,
  panelBankSectionConfigRef,
  isPinned,
  buttonVariant,
  className,
}: PinSectionButtonProps) => {
  const onClick = useCallback(() => {
    const isPinnedMemo = isPinned;
    pinPanelBankSection?.(panelBankSectionConfigRef);
    /*
     * if isPinnedMemo (previous state) is true, the new state is false
     * so we track the 'pin' action, and vice versa
     */
    trackPanelBankEvent({
      action: isPinnedMemo
        ? 'Unpin panel bank section'
        : 'Pin panel bank section',
    });

    if (!isPinnedMemo) {
      window.scrollTo(0, 0);
    }
  }, [isPinned, panelBankSectionConfigRef, pinPanelBankSection]);

  return (
    <Button
      className={className}
      icon="pin"
      variant={buttonVariant}
      tooltip={isPinned ? 'Unpin section' : 'Pin section'}
      aria-label={isPinned ? 'Unpin section' : 'Pin section'}
      tooltipProps={{
        align: 'center',
        side: 'bottom',
      }}
      onClick={onClick}
    />
  );
};
